export const ErrorMsg = {
  required: 'This field is required',
  numbersOnly: 'Only numbers are allowed',
  url: 'Invalid URL',
  email: 'Invalid email',

  min: (value: string): string => `Must be at least ${value} characters`,
  max: (value: string): string => `Must be at most ${value} characters`,
};
